import api from './api';

// Interface base para Item
export interface Item {
  id: number;
  nome: string;
  dataremocao?: string;
  categoria_id?: number;
  principal_id?: number;
  idmongodb?: string;
  idmongodb_categoria?: string;
  mongo_principal?: string;
}

// Interface para criação de Item
export interface ItemCreate {
  nome: string;
  categoria_id?: number;
  principal_id?: number;
  idmongodb?: string;
  idmongodb_categoria?: string;
  mongo_principal?: string;
}

// Interface para atualização de Item
export interface ItemUpdate {
  nome?: string;
  categoria_id?: number;
  principal_id?: number;
  idmongodb?: string;
  idmongodb_categoria?: string;
  mongo_principal?: string;
}

// Interface para filtros de busca
export interface ItemFilter {
  nome?: string;
  categoria_id?: number;
  principal_id?: number;
}

const ItensService = {
  // Obter lista de itens com filtragem e paginação
  getItens: async (filter: ItemFilter = {}, skip: number = 0, limit: number = 10): Promise<Item[]> => {
    try {
      const response = await api.get('/itens/', {
        params: {
          ...filter,
          skip,
          limit
        }
      });
      return response.data || [];
    } catch (error) {
      console.error('Erro ao buscar itens:', error);
      throw error;
    }
  },

  // Obter item por ID
  getItemById: async (id: number): Promise<Item> => {
    try {
      const response = await api.get(`/itens/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Erro ao buscar item ${id}:`, error);
      throw error;
    }
  },

  // Criar novo item
  createItem: async (item: ItemCreate): Promise<Item> => {
    try {
      const response = await api.post('/itens/', item);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar item:', error);
      throw error;
    }
  },

  // Atualizar item existente
  updateItem: async (id: number, item: ItemUpdate): Promise<Item> => {
    try {
      const response = await api.put(`/itens/${id}`, item);
      return response.data;
    } catch (error) {
      console.error(`Erro ao atualizar item ${id}:`, error);
      throw error;
    }
  },

  // Excluir item
  deleteItem: async (id: number): Promise<void> => {
    try {
      await api.delete(`/itens/${id}`);
    } catch (error) {
      console.error(`Erro ao excluir item ${id}:`, error);
      throw error;
    }
  },

  // Obter contagem total
  getItensCount: async (filter: ItemFilter = {}): Promise<number> => {
    try {
      const response = await api.get('/itens/count', {
        params: filter
      });
      return response.data || 0;
    } catch (error) {
      console.error('Erro ao obter contagem de itens:', error);
      throw error;
    }
  },

  // Obter todos os itens para dropdown
  getAllItens: async (): Promise<Item[]> => {
    try {
      const response = await api.get('/itens/all/list');
      return response.data || [];
    } catch (error) {
      console.error('Erro ao buscar lista de itens:', error);
      throw error;
    }
  },

  // Obter itens por categoria
  getItensByCategoria: async (categoriaId: number): Promise<Item[]> => {
    try {
      const response = await api.get(`/itens/by-categoria/${categoriaId}`);
      return response.data || [];
    } catch (error) {
      console.error(`Erro ao buscar itens da categoria ${categoriaId}:`, error);
      throw error;
    }
  }
};

export default ItensService;
